import React from "react";
import { styled } from "../../stitches.config";
import { bodySmall } from "../commonStyles/Fonts";

type ContentsProps = {
    elements: Array<{
        title?: string;
        anchor?: string;
        type?: string;
    }>;
};

export const Contents: React.FC<ContentsProps> = ({
    elements
}) => {
    return (
        <WrapperContents>
            <p className={bodySmall()}>Spis treści:</p>
            <Links>
                {elements.map((elements) =>
                    <>
                        {elements.type === "h1" && <a className="contents-h2" href={`#${elements.anchor}`}>{elements.title}</a>}
                        {elements.type === "h2" && <a className="contents-h3" href={`#${elements.anchor}`}>{elements.title}</a>}
                        {elements.type === "h3" && <a className="contents-h4" href={`#${elements.anchor}`}>{elements.title}</a>}
                    </>
                )}
            </Links>
        </WrapperContents>
    );
};

const WrapperContents = styled("div", {
    borderTop: "1px solid $grayscale100",
    borderBottom: "1px solid $grayscale100",
    padding: "10px 0 4px 0",
    marginTop: "-20px",
    marginBottom: "20px",
    "@bp4": {
        marginTop: "-40px",
        display: "flex",
        padding: "20px 0 16px 0",
    },
    "& p": {
        margin: "0 0 6px 0",
        "@bp4": {
            margin: "0",
            fontSize: "16px",
            lineHeight: "18px",
        }
    },
    "& .contents-h3": {
        marginLeft: "10px",
    },
    "& .contents-h4": {
        marginLeft: "20px",
    }
});

const Links = styled("div", {
    "@bp4": {
        marginLeft: "20px",
    },
    "a": {
        color: "$primary",
        display: "block",
        fontSize: "14px",
        lineHeight: "16px",
        fontWeight: "bold",
        marginBottom: "6px",
        "&:hover": {
            color: "$primary",
        },
        "@bp4": {
            fontSize: "16px",
            lineHeight: "18px",
            marginBottom: "4px",
        }
    }
});

export default Contents;
